const updateFunc = (controlData) => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const h = 1000 - prevalence;
  const d = prevalence;

  const calculatedData = {};
  calculatedData.d = `${d} ${d === 1 ? "person" : "people"}`;
  calculatedData.h = `${h} ${h === 1 ? "person" : "people"}`;
  return calculatedData;
};

export default updateFunc;
